import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { Auth, AuthStrategy, OktaUserclaim } from './auth.interfaces';
import * as fromAuth from './auth.reducer';

/**
 * Feature selector for the auth state
 */
export const getAuthState: MemoizedSelector<object, Auth> = createFeatureSelector<Auth>('auth');
/**
 * Selector to get the AD user from the state
 */
export const getADUser: MemoizedSelector<object, adal.User> = createSelector(
  getAuthState,
  fromAuth.getADUser
);
/**
 * Selector to get the AD user id from the state
 */
export const getUserId: MemoizedSelector<object, string> = createSelector(
  getADUser,
  (user) => user && user.profile && user.profile.oid
);
/**
 * Selector to get the login state
 */
export const getIsLoggedIn: MemoizedSelector<object, boolean> = createSelector(
  getAuthState,
  fromAuth.isLoggedIn
);

/**
 * Selector to check if there is a user logging in
 */
export const getIsSettingUser: MemoizedSelector<object, boolean> = createSelector(
  getAuthState,
  fromAuth.isSettingUser
);

/**
 * Selector to check if there is a user login failed
 */
export const getLoginFailed: MemoizedSelector<object, boolean> = createSelector(
  getAuthState,
  fromAuth.loginFailed
);

/**
 * Selector to get the AD user from the state
 */
export const getInternalUserToken: MemoizedSelector<object, string> = createSelector(
  getADUser,
  (user) => user && user.profile && user.profile.permissionToken
);
/**
 * Selector to get the AD user from the state
 */
export const getGraphToken: MemoizedSelector<object, string> = createSelector(
  getADUser,
  (user) => user && user.profile && user.profile.graphToken
);

/**
 * Selector to get the login state
 */
 export const getUserType: MemoizedSelector<object, string> = createSelector(
  getAuthState,
  fromAuth.userType
);


/**
 * Selector to get the auth strategy
 */
 export const getAuthenticationStrategy: MemoizedSelector<object, AuthStrategy> = createSelector(
  getAuthState,
  fromAuth.getAuthStrategy
);

/**
 * Selector to get the auth status
 */
export const getIsAuthenticated:  MemoizedSelector<object, boolean> = createSelector(
  getAuthState,
  fromAuth.getIsAuthenticated
);

export const getAuthenticationStarted: MemoizedSelector<object, boolean> = createSelector(
  getAuthState,
  fromAuth.getAuthenticationStarted
);

export const getAuthenticationEnded: MemoizedSelector<object, boolean> = createSelector(
  getAuthState,
  fromAuth.getAuthenticationEnded
);

export const getOktaUserclaim: MemoizedSelector<object, OktaUserclaim> = createSelector(
  getAuthState,
  fromAuth.getOktaUserclaim
);
